import {
  Box,
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../../constants/FieldsConst';
import { useNotification } from '../../../../../helpers/Notification';
import { LoadingWidget } from '../../../../../widgets';
import BotonComponent from '../../../../dashboard/components/BotonNuevo';
import SelectFieldSeccionesComponent from '../../../secciones/components/SelectFieldSecciones';
import { oneMatriculasAction } from '../../MatriculasAction';
import { saveMatSeccionesAction } from '../MatSeccionesAction';

const FormMatSecciones = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const matSeccionesStore = Redux.useSelector((state) => state.matSecciones);
  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const matriculasStore = Redux.useSelector((state) => state.matriculas);

  const activo = matSeccionesStore.activo;

  const initData = {
    aprobado: false,
    idSeccion: '',
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({});
  const [loadingSave, setLoadingSave] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(
      () =>
        setData({
          ...values,
          idEntidad: entidadesStore.activo.id,
          idSeccion: activo.seccion.id,
        }),
      300,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }
    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveMatSeccionesAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idMatricula: matriculasStore.activo.id,
          idEntidad: entidadesStore.activo.id,
        },
        matSeccionesStore.params,
      );
      if (res) {
        await oneMatriculasAction(dispatch, matriculasStore.activo.id);
        setOpenModalForm(false);
      }
      setLoadingSave(false);
    }
  };

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}
        <Grid item xs={12} md={12}>
          <FormControl fullWidth size="small" required>
            <InputLabel id={`label_${CONST.aprobado.name}`}>
              Aprobado la sección
            </InputLabel>
            <Select
              id={CONST.aprobado.name}
              value={data.aprobado}
              required
              labelId={`label_${CONST.aprobado.name}`}
              label="Aprobado la sección"
              onChange={(e) =>
                _handleSetDataField(CONST.aprobado.name, e.target.value)
              }
            >
              <MenuItem value={true}>SI</MenuItem>
              <MenuItem value={false}>NO</MenuItem>
            </Select>
          </FormControl>
        </Grid>
        <Grid item xs={12} md={12}>
          <SelectFieldSeccionesComponent
            value={data.idSeccion}
            isAllText={false}
            isAll={false}
            isEmpty={false}
            onChange={(idSeccion) =>
              _handleSetDataField(CONST.seccion.idName, idSeccion)
            }
          />
        </Grid>
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            disabled={loadingSave}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormMatSecciones;
